import { AnonymousLegalDocuments } from 'projects/borrower-app/src/app/models/anonymous-legal-documents.model';

export type LegalDocument = 'termsOfUse' | 'privacyPolicy';

/** True when the HTML has no visible text (null, whitespace, or an empty rich-text value like `<p><br></p>`). */
export function isBlankHtml(html: string | null | undefined): boolean {
  if (!html) {
    return true;
  }
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim().length === 0;
}

/** The lender's document for the active language: Spanish → English → null (caller shows the static default). */
export function pickCustomLegalHtml(docs: AnonymousLegalDocuments | null, doc: LegalDocument, lang: string): string | null {
  if (!docs) {
    return null;
  }
  const english = doc === 'termsOfUse' ? docs.termsOfUseHtml : docs.privacyPolicyHtml;
  const spanish = doc === 'termsOfUse' ? docs.termsOfUseHtmlSpanish : docs.privacyPolicyHtmlSpanish;
  if (lang === 'es' && !isBlankHtml(spanish)) {
    return spanish;
  }
  return isBlankHtml(english) ? null : english;
}

/** Root-relative link (works from any route depth) to the borrower app's Terms/Privacy page, which shows the lender's documents for the active language. */
export function legalDocumentsPageHref(companyGuid: string | null | undefined): string {
  return companyGuid ? `/terms-and-conditions?companyGuid=${encodeURIComponent(companyGuid)}` : '/terms-and-conditions';
}

/**
 * Loads a legal document for a dialog; on failure calls `report` (show an error — and, for OnPush callers,
 * mark the view for check, since this runs after the click's change detection) and returns null.
 */
export async function loadLegalDocumentOrReport(load: () => Promise<string>, report: () => void): Promise<string | null> {
  try {
    return await load();
  } catch {
    report();
    return null;
  }
}
